var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-drawer',{attrs:{"width":"70%","visible":_vm.open},on:{"close":_vm.onClose}},[_c('a-divider',{attrs:{"orientation":"left"}},[_c('b',[_vm._v("统一订单详情")])]),_c('a-empty',{attrs:{"description":"详情内容待补充"}},[(_vm.orderId)?[_vm._v(" 订单编号："+_vm._s(_vm.orderId)+" ")]:_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }